var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"p-empty-message tw-flex tw-items-center tw-justify-center"},[_c('div',{staticClass:"p-empty-message--box tw-text-center"},[_c('p',{staticClass:"text-uppercase tw-m-0"},[_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f7a5f88","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/shared/components/ui/p-empty-message.vue
// module id = 1469
// module chunks = 3 9 12 16 24 25 28 31 32 33 34 35 49 59